export default [
    {
        name: 'login',
        path: '/login',
        component: () => import('@/views/login.vue'),
        meta: { requireAuth: false }
    },
    {
        name: 'forgot_password',
        path: '/forgot_password',
        component: () => import('@/views/forgot_password.vue'),
        meta: { requireAuth: false }
    },
    {
        // o link do e-mail aponta para {CLIENT_URL}/recover_password/{hash}?email={email}
        name: 'recover_password',
        path: '/recover_password/:hash',
        component: () => import('@/views/recover_password.vue'),
        meta: { requireAuth: false }
    },
    {
        name: 'admin_login',
        path: '/admin/login',
        component: () => import('@/views/admin/login.vue'),
        meta: { requireAdminAuth: false }
    },
    {
        name: 'admin_home',
        path: '/admin',
        component: () => import('@/views/admin/home.vue'),
        meta: { requireAdminAuth: true }
    },
    {
        name: 'admin_tenants',
        path: '/admin/empresas',
        component: () => import('@/views/admin/tenants.vue'),
        meta: { requireAdminAuth: true }
    },
    {
        name: 'admin_transactions',
        path: '/admin/transactions',
        component: () => import('@/views/admin/transactions.vue'),
        meta: { requireAdminAuth: true }
    },
    {
        name: 'admin_partners',
        path: '/admin/partners',
        component: () => import('@/views/admin/partners.vue'),
        meta: { requireAdminAuth: true }
    },
    {
        name: 'home',
        path: '/',
        component: () => import('@/views/home.vue'),
        meta: { requireAuth: true },
        children: [
            {
                name: 'profile',
                path: '/profile',
                component: () => import('@/views/profile.vue'),
            },
        ]
    },
    {
        name: 'clients_login',
        path: '/clients/login/:cnpj?',
        component: () => import('@/views/clients/login.vue'),
        meta: { requireClientAuth: false }
    },
    {
        name: 'clients_home',
        path: '/clients',
        component: () => import('@/views/clients/home.vue'),
        meta: { requireClientAuth: true },
        children: [
            {
                name: 'clients_profile',
                path: '/clients/profile',
                component: () => import('@/views/clients/profile.vue'),
            },
        ]
    },
];
